import * as React from 'react';
import { BookMeetingSectionBlockCallToActionType } from '../ViewModel/BookMeetingSectionBlockCallToActionType.csharp';
import type { BookMeetingSectionBlockViewModel } from '../ViewModel/BookMeetingSectionBlockViewModel.csharp';
import type { BookMeetingSectionCTAProps } from '~/Features/StudyPage/Campus/Sections/BookMeetingSection/BookMeetingSection';
import { BookMeetingSection } from '~/Features/StudyPage/Campus/Sections/BookMeetingSection/BookMeetingSection';
import { assertNever } from '~/Partials/Utils/typeUtils';

export const BookMeetingSectionBlock: React.FC<React.PropsWithChildren<BookMeetingSectionBlockViewModel>> = props => {
    const {
        translations,
        bookingConfirmationHeading,
        bookingConfirmationMessage,
        id,
        callToActionType,
        callToActionLabel,
        callToActionLink,
        submitUrl,
        formHeading,
        attendanceOptions,
        timeSlots,
        termsAndConditionsText,
        ...commonProps
    } = props;

    const getCallToActionProps = (): BookMeetingSectionCTAProps => {
        switch (callToActionType) {
            case BookMeetingSectionBlockCallToActionType.ButtonWithOverlay:
                return {
                    type: 'button',
                    label: callToActionLabel,
                    translations: {
                        closeLabel: translations.labelCloseOverlayButton,
                        overlayLabel: translations.labelOverlay,
                    },
                    overlayContent: {
                        formId: id,
                        submitUrl,
                        formHeading,
                        attendanceOptions,
                        timeSlots,
                        termsAndConditionsText,
                        confirmationHeading: bookingConfirmationHeading,
                        confirmationMessage: bookingConfirmationMessage,
                        confirmationButtonLabel: translations.labelBookingConfirmationButton,
                        translations: {
                            ...translations,
                            emailIsInvalidError: translations.invalidEmail,
                        },
                    },
                };
            case BookMeetingSectionBlockCallToActionType.Link:
                return {
                    type: 'link',
                    ...callToActionLink,
                };
            default:
                assertNever(callToActionType);
        }
    };

    return <BookMeetingSection id={id} {...commonProps} callToAction={getCallToActionProps()} />;
};
